module.exports = __webpack_public_path__ + "static/img/蒙版组 29.260b8ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 29.png
// module id = HviB
// module chunks = 1